import {
  SET_MEMBERSHIP_MODAL_ID,
  SET_MEMBERSHIP_MODAL_IS_VISIBLE
} from './types'

export const state = {
  isVisible: false
}

export const mutations = {
  [SET_MEMBERSHIP_MODAL_ID] (state, value) {
    state.id = value
  },
  [SET_MEMBERSHIP_MODAL_IS_VISIBLE] (state, value) {
    state.isVisible = value
  }
}

export const actions = {
  openMembershipModal ({ commit, dispatch }, user) {
    dispatch('prepareMembershipModal')
    dispatch('membershipForm/setUserId', user.id)
  },
  closeMembershipModal ({ commit }) {
    commit(SET_MEMBERSHIP_MODAL_IS_VISIBLE, false)
  },
  prepareMembershipModal ({ commit, dispatch }) {
    dispatch('membershipForm/reset')
    dispatch('fetchTeams')
    commit(SET_MEMBERSHIP_MODAL_IS_VISIBLE, true)
  }
}

export const getters = {
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/memberships/membershipModal.js